import { KampaayDataProvider } from 'services/api/dataProvider'
import { ProfessionalFigure } from 'services/api/entities/catalog/professional/types/internal/professional-models'
import { parseCsvFields } from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'
import { formatHighlights } from './common'

export const professionals: EntityDescriptor<ProfessionalFigure> = {
  format: (_dataProvider?: KampaayDataProvider) => (record) => {
    const { name, description, highlights, advanceReservationMin, ...rest } =
      record

    return {
      ...parseCsvFields({ name, description }),
      'Booking time-limit': advanceReservationMin,
      highlights: formatHighlights(highlights),
      ...rest,
    }
  },
}
